import * as React from 'react';

function Fraud0({ fraud0Id  }) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("script", {
        async: true,
        src: `https://bt.fraud0.com/api/v2/fz.js?cid=${fraud0Id}`
    }));
}
function Fraud0ConversionTag() {
    const CONVERSION_TAG = `fraud0 = window.fraud0 || [];fraud0.push([1]);`;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("script", {
        type: "text/javascript"
    }, CONVERSION_TAG));
}

export { Fraud0, Fraud0ConversionTag };
//# sourceMappingURL=Fraud0.js.map
